if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      document.addEventListener('DOMContentLoaded', this.setTransparentClass.bind(this));

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
          window.dispatchEvent(new Event('scroll'));
        } else {
          this.classList.add('is-sticky');
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        document.querySelector('.product-information')?.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
    setTransparentClass() {
      this.template_header = document.querySelector('.template-header');

      if (this.template_header && this.template_header.classList.contains('template-header--has-image-true') && this.template_header.dataset.sectionIndex == 1) {
        this.classList.remove('transparent--false');
        this.classList.add('transparent--true');
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.mobile-toggle-wrapper');
  const item = document.querySelector('.style3 .thb-secondary-area-item');
  const cartButton = document.querySelector('.thb-header-mobile-left');
  const closeButtons = document.querySelectorAll('.side-panel-close');

  if (!toggle) return;

  const updateSecondaryArea = (isOpen) => {
    if (item) item.style.display = isOpen ? 'flex' : 'none';
  };

  const openPanel = () => {
    toggle.classList.add('open', 'active');
    updateSecondaryArea(true);
    if (cartButton) cartButton.classList.add('menu-open'); // ✅ add menu-open when toggle clicked
  };

  const closePanel = () => {
    toggle.classList.remove('open', 'active');
    updateSecondaryArea(false);
    if (cartButton) cartButton.classList.remove('menu-open'); // remove menu-open when close button clicked
  };

  // Toggle click
  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    const isOpen = toggle.classList.contains('open');
    if (isOpen) {
      closePanel();
    } else {
      openPanel();
    }
  });

  // Close button click
  closeButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      closePanel();
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {

  /* 1) Stop menu from closing when clicking inside it */
  const inner = document.querySelector('.mobile-menu-drawer--inner');
  if (inner) {
    inner.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }

  /* 2) Sync cart count to the mobile toggle (auto-updates) */
  function syncMobileMenuCount() {
    const source = document.querySelector('.thb-secondary-area-item .thb-item-count');
    let target = document.querySelector('.mobile-toggle .thb-item-count');

    if (!source) return;

    // Recreate mobile count bubble if theme overwrote it
    if (!target) {
      const toggle = document.querySelector('.mobile-toggle');
      if (toggle) {
        target = document.createElement('span');
        target.className = 'thb-item-count';
        toggle.appendChild(target);
      }
    }

    if (target) {
      const val = source.textContent.trim();
      target.textContent = val;
      target.style.display = val !== "" && val !== "0" ? 'inline-block' : 'none';
    }
  }

  // Run on load
  syncMobileMenuCount();

  // Watch for cart changes (MutationObserver ensures updates on Ajax add-to-cart)
  const cartCountSource = document.querySelector('.thb-secondary-area-item .thb-item-count');
  if (cartCountSource) {
    new MutationObserver(syncMobileMenuCount).observe(cartCountSource, {
      characterData: true,
      subtree: true,
      childList: true
    });
  }

  /* 3) Prevent THB from auto-closing menu on link click (fix flicker) */
  document.querySelectorAll('.mobile-menu a[href]').forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');

      // Ignore dummy / expandable links
      if (!href || href === '#') {
        e.preventDefault();
        return;
      }

      // Prevent THB auto-close flicker
      e.stopImmediatePropagation();
      e.stopPropagation();

      // Allow new-tab behavior
      if (e.metaKey || e.ctrlKey || e.shiftKey || this.target === '_blank') {
        return;
      }

      // Navigate instantly = no header flicker
      e.preventDefault();
      window.location.href = href;
    }, true); // capture phase
  });

  /* 4) Add-to-Cart bar scroll behavior for mobile with stable visibility */
const addToCartBar = document.querySelector(".display-featured-separately .product-add-to-cart-container");
if (addToCartBar) {
  const initialViewportHeight = window.innerHeight; // store once
  let addToCartVisible = false; // track if bar became visible

  // Initially hide
  addToCartBar.classList.remove("visible");

  function handleScroll() {
    if (window.innerWidth <= 1067) {
      const scrollY = window.scrollY;

      // Show after first scroll past 30% of initial viewport height
      if (scrollY > initialViewportHeight * 0.3 && !addToCartVisible) {
        addToCartBar.classList.add("visible");
        addToCartVisible = true; // once visible, stay visible
      }
    } else {
      // Hide on desktop
      addToCartBar.classList.remove("visible");
      addToCartVisible = false;
    }
  }

  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", handleScroll);

}


});
